import Http from "@/api/http";

export default {
  indexFlow(filter) {
    return Http.get(`/flows`, {
      params: {
        // solution_id: localStorage.getItem("solution_id"),
        ...filter,
      },
    });
  },

  showFlow(id) {
    return Http.get(`/flows/${id}`);
  },
  getFlowPDF(id){
    return Http.get(`/flows/${id}.pdf`, { responseType: 'blob' });
  },

  createFlow(flow) {
    return Http.post(`/flows`, {flow: {...flow}});
  },

  updateFlow(flow) {
    return Http.put(`/flows/${flow.id}`, {flow: {...flow}});
  },

  duplicateFlow(flow) {
    return Http.post(`/flows/duplicate`, {flow: {...flow}});
  },

  reorderGroups(flow) {
    return Http.put(`/flows/${flow.id}/reorder_groups`, {flow: {...flow}});
  },




  indexGroup(filter, flow_id) {
    return Http.get(`/flows/${flow_id}/groups`, {
      params: {
        // solution_id: localStorage.getItem("solution_id"),
        ...filter,
      },
    });
  },

  showGroup(id) {
    return Http.get(`/groups/${id}`);
  },

  createGroup(group) {
    return Http.post(`/groups`, {group: {...group}});
  },

  updateGroup(group) {
    return Http.put(`/groups/${group.id}`, {group: {...group}});
  },
  deleteGroup(group_id) {
    return Http.delete(`/groups/${group_id}`);
  },







  indexStepByFlow(filter, flow_id) {
    return Http.get(`/flows/${flow_id}/steps`, {
      params: {
        // solution_id: localStorage.getItem("solution_id"),
        ...filter,
      },
    });
  },

  showStep(id) {
    return Http.get(`/steps/${id}`);
  },

  createStep(step) {
    return Http.post(`/steps`, {step: {...step}});
  },

  updateStep(step) {
    return Http.put(`/steps/${step.id}`, {step: {...step}});
  },



  beginExecution(flow_id, version_control) {
    console.log({version_control});
    return Http.post(`/flows/${flow_id}/begin_execution`, 
      {
        version_control: version_control
      }
    )
  },

  updateDoneStep(done_step) {
    return Http.put(`/done_steps/${done_step.id}`, {done_step: {...done_step}});
  }
};
